export const ImportUploadStatus = {
  Default: "default",
  Uploading: "uploading",
  Success: "success",
  Error: "error",
};
